<template>
  <p class="headline text-center">404 Not Found !</p>
</template>

<script lang="ts">
import Vue, { defineComponent } from "vue";

export default defineComponent({});
</script>